module.exports = __webpack_public_path__ + "img/4cfd72f.png";